'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Envelope;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Envelope(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-envelope ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { d: 'M.5 2h15a.5.5 0 0 1 .5.5v2.223a.5.5 0 0 1-.235.424l-7.5 4.687a.5.5 0 0 1-.53 0l-7.5-4.687A.5.5 0 0 1 0 4.723V2.5A.5.5 0 0 1 .5 2zM0 6.598l7.735 4.834a.5.5 0 0 0 .53 0L16 6.598v7.5a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-7.5z' })
  );
}

Envelope.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Envelope/Envelope.js
// module id = 1175
// module chunks = 1